module.exports = __webpack_public_path__ + "img/logo.509fec73.svg";